import { ComposedCondition } from '@hyper-inferno/survey-elements-core';
import { isNumNotDefined, isOptionSelected } from './number-check';

export const OPERATOR_FUNCTIONS: Record<
  string,
  (userVal: any, cond: ComposedCondition) => boolean
> = {
  // --- Choice Logic ---
  // Expects userValue to be a number[] .option_key)
  // Is: checks if the array contains exactly this one key and nothing else
  is: (uv: number[], c) => uv.length === 1 && uv[0] === Number(c.option_key),

  // Is Not: true if the array doesn't contain the key, or contains other things too
  is_not: (uv, c) =>
    isOptionSelected(uv) &&
    Number(Array.isArray(uv) ? uv[0] : uv) !== Number(c.option_key),

  // Expects userValue to be an array of strings .option_keys)
  inc_any: (uv: number[], c) =>
    Array.isArray(uv) && uv.some((val) => c.option_keys.includes(val)),
  inc_all: (uv, c) => {
    // Checks if the user's selected options (uv) include ALL keys in c.option_keys
    if (!Array.isArray(uv) || !c.option_keys) return false;
    return c.option_keys.every((key) => uv.includes(key));
  },
  is_ex: (uv, c) => {
    // Checks if the user's selection is exactly the target set (order-independent)
    if (!Array.isArray(uv) || !c.option_keys) return false;
    return (
      uv.length === c.option_keys.length &&
      uv.every((val) => c.option_keys.includes(val))
    );
  },

  // --- Text Logic ---
  // Case-insensitive comparisons are usually safer for surveys
  eq_text: (uv, c) =>
    String(uv || '').toLowerCase() ===
    String(JSON.parse(c.value_manual) || '').toLowerCase(),
  cont: (uv, c) =>
    String(uv || '')
      .toLowerCase()
      .includes(String(JSON.parse(c.value_manual) || '').toLowerCase()),
  sw: (uv, c) =>
    String(uv || '')
      .toLowerCase()
      .startsWith(String(JSON.parse(c.value_manual) || '').toLowerCase()),

  // --- Numeric Logic ---
  eq_num: (uv, c) => {
    console.log(uv, c.value_manual, JSON.parse(c.value_manual));
    return (
      isNumNotDefined(uv) && Number(uv) === Number(JSON.parse(c.value_manual))
    );
  },
  neq_num: (uv, c) =>
    isNumNotDefined(uv) && Number(uv) !== Number(JSON.parse(c.value_manual)),
  gt: (uv, c) =>
    isNumNotDefined(uv) && Number(uv) > Number(JSON.parse(c.value_manual)),
  lt: (uv, c) =>
    isNumNotDefined(uv) && Number(uv) < Number(JSON.parse(c.value_manual)),
  bet_num: (uv, c) => {
    // Expects value_manual to be an array [min, max] or an object {min, max}
    const val = Number(uv);
    const { min, max } = JSON.parse(c.value_manual) || {};
    return val >= min && val <= max;
  },

  // --- State Logic ---
  ans: (uv) =>
    uv !== undefined &&
    uv !== null &&
    uv !== '' &&
    uv !== 0 &&
    !(Array.isArray(uv) && (uv.length === 0 || uv[0] === 0 || uv[0] === '')),
  nans: (uv) =>
    uv === undefined ||
    uv === null ||
    uv === '' ||
    (Array.isArray(uv) && uv.length === 0),
};
